import { HttpErrorResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { PolicyToAdd, PolicyType } from "src/app/models/api/governance/policy.model";
import { ISelectOption } from "src/app/models/selectOptions";
import { PolicyTypeSelectOptions } from "src/app/models/selectOptions/policyTypeSelectOptions.model";
import { PoliciesHttpService } from "src/app/services/httpServices/governance/policiesHttpService/policies-http.service";
import { HttpErrorHandlerService } from "src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service";
import { NotificationsService } from "src/app/services/infra/notifications/notifications.service";

@Component({
    selector: "app-add-policy",
    templateUrl: "./add-policy-dialog.component.html",
    styleUrls: ["./add-policy-dialog.component.scss"],
})
export class AddPolicyDialogComponent implements OnInit, OnDestroy {
    public addPolicyFormGroup: UntypedFormGroup;

    public policyTypes: ISelectOption[] = PolicyTypeSelectOptions.filter((type) => type.value !== PolicyType.default);

    public waitingForResponse = false;

    private _policyTypeSelected: ISelectOption | undefined;
    private _addPolicySubscription$?: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) public integrationId: string,
        public dialogRef: MatDialogRef<AddPolicyDialogComponent>,
        private _formBuilder: UntypedFormBuilder,
        private _policiesHttpService: PoliciesHttpService,
        private _httpErrorHandlerService: HttpErrorHandlerService,
        private _notificationService: NotificationsService,
    ) {}

    ngOnInit(): void {
        this.addPolicyFormGroup = this._formBuilder.group({
            policyName: this._formBuilder.control("", [Validators.required]),
            policyType: this._formBuilder.control(this._policyTypeSelected?.displayName, [Validators.required]),
        });
    }

    ngOnDestroy() {
        this._addPolicySubscription$?.unsubscribe();
    }

    public onClose(): void {
        this.dialogRef.close();
    }

    public onPolicyTypeSelection(selectedPolicyType: ISelectOption) {
        this._policyTypeSelected = this.policyTypes.find((type) => type.id === selectedPolicyType.id);
        this.addPolicyFormGroup.controls["policyType"].setValue(this._policyTypeSelected?.displayName);
    }

    public addPolicy() {
        this.waitingForResponse = true;
        const policyType: PolicyType = PolicyType[this.addPolicyFormGroup.controls["policyType"].value.toLowerCase() as PolicyType];
        this._addPolicySubscription$ = this._policiesHttpService
            .addPolicy(this.integrationId, {
                name: this.addPolicyFormGroup.controls["policyName"].value,
                type: policyType,
            } as PolicyToAdd)
            .subscribe({
                next: () => {
                    this._notificationService.success("Policy added successfully");
                    this.dialogRef.close(true);
                },
                error: (httpError: HttpErrorResponse) => {
                    if (this._httpErrorHandlerService.isUnhandledExceptionError(httpError.status)) {
                        this._httpErrorHandlerService.handle(httpError);
                    } else {
                        this._notificationService.error(httpError.error.detail);
                    }
                    this.waitingForResponse = false;
                },
            });
    }
}
